// Auto-generated enum types and metadata
// DO NOT EDIT - Changes will be overwritten

export enum ActionKind {
  FUNCTIONAL = "functional",
  VERIFICATION_CASE = "verification_case",
  DECISION = "decision",
  FORK = "fork",
  JOIN = "join",
  MERGE = "merge",
}

export enum AllocationKind {
  HARDWARE = "hardware",
  SOFTWARE = "software",
  MIXED = "mixed",
}

export enum AttachmentResolution {
  INTEGRAL = "integral",
  HARDWARE = "hardware",
  TBD = "tbd",
}

export enum AttributeValueKind {
  TARGET = "target",
  MEASURED = "measured",
  ESTIMATED = "estimated",
}

export enum ClosureIntent {
  SOURCED = "sourced",
  BUILD = "build",
  OPEN = "open",
}

export enum ConstraintKind {
  HARD = "hard",
  SOFT = "soft",
  GUIDELINE = "guideline",
}

export enum ConstraintRole {
  REQUIRE = "require",
  ASSUME = "assume",
}

export enum ConstraintStatus {
  UNKNOWN = "unknown",
  PASSING = "passing",
  FAILING = "failing",
  NOT_APPLICABLE = "not_applicable",
  STALE = "stale",
}

export enum Criticality {
  CATASTROPHIC = "catastrophic",
  CRITICAL = "critical",
  MARGINAL = "marginal",
  NEGLIGIBLE = "negligible",
}

export enum DataKind {
  BOOL = "bool",
  INT32 = "int32",
  INT64 = "int64",
  FLOAT32 = "float32",
  FLOAT64 = "float64",
  STRING = "string",
  ENUM_REF = "enum_ref",
  STRUCT_REF = "struct_ref",
  BLOB = "blob",
}

export enum DeliveryMode {
  STREAMING = "streaming",
  HANDOFF = "handoff",
  BUFFERED = "buffered",
}

export enum DiscreteKind {
  BOOLEAN = "boolean",
  STRING = "string",
  ENUM = "enum",
}

export enum EarsPattern {
  UBIQUITOUS = "ubiquitous",
  EVENT = "event",
  STATE = "state",
  OPTIONAL = "optional",
  UNWANTED = "unwanted",
  COMPLEX = "complex",
}

export enum EffortVariable {
  VOLTAGE = "voltage",
  FORCE = "force",
  TORQUE = "torque",
  PRESSURE = "pressure",
  TEMPERATURE = "temperature",
  CHEMICAL_POTENTIAL = "chemical_potential",
  MMF = "mmf",
  SOUND_PRESSURE = "sound_pressure",
  OPTICAL_INTENSITY = "optical_intensity",
  SPECTRAL_POWER_DENSITY = "spectral_power_density",
}

export enum ElicitationMethod {
  INTERVIEW = "interview",
  WORKSHOP = "workshop",
  DOCUMENT = "document",
  OBSERVATION = "observation",
  SURVEY = "survey",
  OTHER = "other",
}

export enum ExpressionType {
  TEXT = "text",
  NUMERIC = "numeric",
  LOGICAL = "logical",
}

export enum FlowType {
  MATTER = "matter",
  ENERGY = "energy",
  INFORMATION = "information",
}

export enum FlowVariable {
  CURRENT = "current",
  VELOCITY = "velocity",
  ANGULAR_VEL = "angular_vel",
  VOLUMETRIC = "volumetric",
  ENTROPY_RATE = "entropy_rate",
  MOLAR_FLOW = "molar_flow",
  MAGNETIC_FLUX = "magnetic_flux",
  PARTICLE_VELOCITY = "particle_velocity",
  PHOTON_FLUX = "photon_flux",
}

export enum InterfaceCategory {
  MECHANICAL = "mechanical",
  ELECTRICAL = "electrical",
  FLUIDIC = "fluidic",
  THERMAL = "thermal",
  DATA_BUS = "data_bus",
}

export const InterfaceCategoryMetadata = {
  MECHANICAL: {
    value: "mechanical",
    description: "Mechanical connector / mount / coupling",
    examples: [],
    color: "bg-gray-100 text-gray-800",
    icon: "🔧",
  },
  ELECTRICAL: {
    value: "electrical",
    description: "Electrical connector — USB, JST, terminal, etc.",
    examples: [],
    color: "bg-gray-100 text-gray-800",
    icon: "⚡",
  },
  FLUIDIC: {
    value: "fluidic",
    description: "Fluidic connector — hose barb, quick-disconnect, tube fitting",
    examples: [],
    color: "bg-gray-100 text-gray-800",
    icon: "💧",
  },
  THERMAL: {
    value: "thermal",
    description: "Thermal interface — heat-pipe coupling, contact pad",
    examples: [],
    color: "bg-gray-100 text-gray-800",
    icon: "🔥",
  },
  DATA_BUS: {
    value: "data_bus",
    description: "Logical data bus — CAN, I2C, SPI, Ethernet, MQTT",
    examples: [],
    color: "bg-gray-100 text-gray-800",
    icon: "🔗",
  },
} as const;

export type InterfaceCategoryMetadataType = typeof InterfaceCategoryMetadata;

export enum ItemIdentity {
  FUNGIBLE = "fungible",
  INDIVIDUAL = "individual",
}

export enum LogicalKind {
  COMPOSITE = "composite",
  HARDWARE_LEAF = "hardware_leaf",
  SOFTWARE_LEAF = "software_leaf",
}

export enum ModularityIntent {
  REQUIRED = "required",
  PREFERRED = "preferred",
  NONE = "none",
}

export enum MoscowPriority {
  MUST = "must",
  SHOULD = "should",
  COULD = "could",
  WONT = "wont",
}

export enum NISTFunctionVerb {
  CONVERT = "convert",
  TRANSFER = "transfer",
  TRANSPORT = "transport",
  TRANSMIT = "transmit",
  GUIDE = "guide",
  CHANNEL = "channel",
  COUPLE = "couple",
  MIX = "mix",
  SEPARATE = "separate",
  DISTRIBUTE = "distribute",
  BRANCH = "branch",
  IMPORT = "import",
  EXPORT = "export",
  STORE = "store",
  SUPPLY = "supply",
  COLLECT = "collect",
  CONTAIN = "contain",
  STOP = "stop",
  INHIBIT = "inhibit",
  PREVENT = "prevent",
  REGULATE = "regulate",
  CHANGE = "change",
  INCREASE = "increase",
  DECREASE = "decrease",
  ACTUATE = "actuate",
  CONTROL_MAGNITUDE = "control_magnitude",
  SIGNAL = "signal",
  PROVISION = "provision",
  SUPPORT = "support",
  STABILIZE = "stabilize",
  SECURE = "secure",
  POSITION = "position",
}

export enum NumericShape {
  SCALAR = "scalar",
  RANGE = "range",
  VECTOR = "vector",
}

export enum PhysicsDomain {
  MECH_TRANS = "mech_trans",
  MECH_ROT = "mech_rot",
  ELECTRICAL = "electrical",
  HYDRAULIC = "hydraulic",
  PNEUMATIC = "pneumatic",
  THERMAL = "thermal",
  CHEMICAL = "chemical",
  MAGNETIC = "magnetic",
  ACOUSTIC = "acoustic",
  OPTICAL = "optical",
  RADIANT = "radiant",
}

export const PhysicsDomainMetadata = {
  MECH_TRANS: {
    value: "mech_trans",
    description: "Mechanical translation — force / linear velocity",
    examples: [],
    color: "bg-gray-100 text-gray-800",
    icon: "↔",
  },
  MECH_ROT: {
    value: "mech_rot",
    description: "Mechanical rotation — torque / angular velocity",
    examples: [],
    color: "bg-gray-100 text-gray-800",
    icon: "🌀",
  },
  ELECTRICAL: {
    value: "electrical",
    description: "Electrical — voltage / current",
    examples: [],
    color: "bg-gray-100 text-gray-800",
    icon: "⚡",
  },
  HYDRAULIC: {
    value: "hydraulic",
    description: "Hydraulic — pressure / volumetric flow (liquid)",
    examples: [],
    color: "bg-gray-100 text-gray-800",
    icon: "💧",
  },
  PNEUMATIC: {
    value: "pneumatic",
    description: "Pneumatic — pressure / volumetric flow (gas)",
    examples: [],
    color: "bg-gray-100 text-gray-800",
    icon: "💨",
  },
  THERMAL: {
    value: "thermal",
    description: "Thermal — temperature / entropy rate",
    examples: [],
    color: "bg-gray-100 text-gray-800",
    icon: "🔥",
  },
  CHEMICAL: {
    value: "chemical",
    description: "Chemical — chemical potential / molar flow",
    examples: [],
    color: "bg-gray-100 text-gray-800",
    icon: "🧪",
  },
  MAGNETIC: {
    value: "magnetic",
    description: "Magnetic — MMF / magnetic flux",
    examples: [],
    color: "bg-gray-100 text-gray-800",
    icon: "🧲",
  },
  ACOUSTIC: {
    value: "acoustic",
    description: "Acoustic — sound pressure / particle velocity",
    examples: [],
    color: "bg-gray-100 text-gray-800",
    icon: "🔊",
  },
  OPTICAL: {
    value: "optical",
    description: "Optical — intensity / photon flux (visible / near-IR)",
    examples: [],
    color: "bg-gray-100 text-gray-800",
    icon: "💡",
  },
  RADIANT: {
    value: "radiant",
    description: "Radiant — broad EM (RF, microwave, IR, UV, solar)",
    examples: [],
    color: "bg-gray-100 text-gray-800",
    icon: "☀",
  },
} as const;

export type PhysicsDomainMetadataType = typeof PhysicsDomainMetadata;

export enum PortDirection {
  IN = "in",
  OUT = "out",
  INOUT = "inout",
}

export enum ProposalOperation {
  CREATE = "create",
  MODIFY = "modify",
  DELETE = "delete",
  LINK = "link",
  UNLINK = "unlink",
}

export enum ProposalStatus {
  PENDING = "pending",
  APPROVED = "approved",
  REJECTED = "rejected",
  APPLIED = "applied",
  SUPERSEDED = "superseded",
}

export enum RequirementCategory {
  FUNCTIONAL = "functional",
  PERFORMANCE = "performance",
  INTERFACE = "interface",
  RELIABILITY = "reliability",
  MAINTAINABILITY = "maintainability",
  USABILITY = "usability",
  SECURITY = "security",
  SAFETY = "safety",
  REGULATORY = "regulatory",
  ENVIRONMENTAL = "environmental",
  DESIGN_CONSTRAINT = "design_constraint",
}

export enum RequirementLifecycle {
  DRAFT = "draft",
  IN_REVIEW = "in_review",
  APPROVED = "approved",
  REJECTED = "rejected",
  OBSOLETE = "obsolete",
}

export enum SignalType {
  COMMAND = "command",
  FEEDBACK = "feedback",
  MEASUREMENT = "measurement",
  STATUS = "status",
  EVENT = "event",
  SYNCHRONIZATION = "synchronization",
}

export const SignalTypeMetadata = {
  COMMAND: {
    value: "command",
    description: "Outbound directive — actuator command, setpoint, request",
    examples: [],
    color: "bg-gray-100 text-gray-800",
    icon: "➡",
  },
  FEEDBACK: {
    value: "feedback",
    description: "Closed-loop return path — sensor reading routed back to a controller",
    examples: [],
    color: "bg-gray-100 text-gray-800",
    icon: "↩",
  },
  MEASUREMENT: {
    value: "measurement",
    description: "Raw sensor reading — no implied control loop",
    examples: [],
    color: "bg-gray-100 text-gray-800",
    icon: "📊",
  },
  STATUS: {
    value: "status",
    description: "Discrete state report — mode, health, ready flag",
    examples: [],
    color: "bg-gray-100 text-gray-800",
    icon: "ℹ",
  },
  EVENT: {
    value: "event",
    description: "Asynchronous discrete notification — fault, threshold cross, completion",
    examples: [],
    color: "bg-gray-100 text-gray-800",
    icon: "🔔",
  },
  SYNCHRONIZATION: {
    value: "synchronization",
    description: "Periodic / timing / phase reference — clock, trigger, sync pulse",
    examples: [],
    color: "bg-gray-100 text-gray-800",
    icon: "⏱",
  },
} as const;

export type SignalTypeMetadataType = typeof SignalTypeMetadata;

export enum SourceDocumentType {
  SPEC = "spec",
  REGULATION = "regulation",
  STANDARD_DOC = "standard_doc",
  NOTE = "note",
  INTERVIEW = "interview",
  OBSERVATION = "observation",
  OTHER = "other",
}

export enum SourcingStatus {
  PROPOSED = "proposed",
  SELECTED = "selected",
  ORDERED = "ordered",
  IN_STOCK = "in_stock",
}

export enum TemporalPattern {
  CONTINUOUS = "continuous",
  DISCRETE = "discrete",
}

export enum VerdictKind {
  PASS = "pass",
  FAIL = "fail",
  INCONCLUSIVE = "inconclusive",
  ERROR = "error",
  NOT_RUN = "not_run",
}

export enum VerificationMethod {
  TEST = "test",
  ANALYSIS = "analysis",
  INSPECTION = "inspection",
  DEMONSTRATION = "demonstration",
}

export enum VerificationStatus {
  NOT_VERIFIED = "not_verified",
  IN_VERIFICATION = "in_verification",
  VERIFIED = "verified",
  FAILED = "failed",
  WAIVED = "waived",
}
